"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocaleContextController = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_intl_1 = require("react-intl");
const x_date_pickers_1 = require("@mui/x-date-pickers");
const AdapterDateFns_1 = require("@mui/x-date-pickers/AdapterDateFns");
const pl_1 = __importDefault(require("date-fns/locale/pl"));
const en_US_1 = __importDefault(require("date-fns/locale/en-US"));
const AppLocale_enum_1 = require("../AppLocale.enum");
const defaultLocale_1 = require("../defaultLocale");
const LocaleContext_1 = require("../localeContext/LocaleContext");
const LocaleContextController = ({ children, translations }) => {
    const [locale, setLocale] = (0, react_1.useState)(defaultLocale_1.defaultLocale);
    return ((0, jsx_runtime_1.jsx)(react_intl_1.IntlProvider, { defaultLocale: defaultLocale_1.defaultLocale, locale: locale, messages: translations[locale], children: (0, jsx_runtime_1.jsx)(LocaleContext_1.LocaleContext.Provider, { value: { defaultLocale: defaultLocale_1.defaultLocale, locale, setLocale }, children: (0, jsx_runtime_1.jsx)(x_date_pickers_1.LocalizationProvider, { dateAdapter: AdapterDateFns_1.AdapterDateFns, adapterLocale: locale === AppLocale_enum_1.AppLocale.pl ? pl_1.default : en_US_1.default, children: children }) }) }));
};
exports.LocaleContextController = LocaleContextController;
